import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Cómo recibo el Rescate Académico después de comprar?',
    answer: 'Inmediatamente después del pago recibís un email con el link de descarga. En menos de 5 minutos tenés todo el material en tu dispositivo.'
  }, {
    question: '¿Sirve para cualquier año de la carrera?',
    answer: 'Sí. Está organizado para acompañarte de 1° a 5° año. Cada tomo cubre un área específica de la carrera con lenguaje adaptado al plan de estudios argentino.'
  }, {
    question: '¿Los 6 bonos están incluidos en las dos opciones?',
    answer: 'Sí. Los 6 bonos están incluidos siempre, tanto en el Rescate Base como en la versión Élite.'
  }, {
    question: '¿Qué agrega la versión Élite?',
    answer: 'Suma los 2 Ebooks de Autoridad Clínica: Interpretación de Imágenes y El Manual Seguro. Son los materiales que te separan de un estudiante promedio y te posicionan como el profesional que los médicos respetan desde el primer día.'
  }, {
    question: '¿Sirve para parciales y finales difíciles?',
    answer: 'Sí. El Bonus 5 (Guía Definitiva de Finales) tiene las preguntas exactas que más se repiten con las respuestas desarrolladas que los docentes esperan escuchar.'
  }, {
    question: '¿Tiene garantía?',
    answer: '7 días de garantía total. Si no te sirve por cualquier motivo, te devolvemos el 100% del dinero. Sin preguntas.'
  }];
  return <section className="w-full bg-slate-50 py-12 md:py-20 px-4" data-id="element-138">
      <div className="max-w-4xl mx-auto" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-140">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-141">
            Preguntas frecuentes
          </h2>
          <p className="text-xl text-slate-600" data-id="element-142">
            Todo lo que necesitás saber antes de decidir.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-143">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-white rounded-lg shadow-md border border-slate-200 overflow-hidden" data-id="element-144">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left hover:bg-slate-50 transition-colors" aria-expanded={openIndex === i} data-id="element-145">
                <span className="font-bold text-slate-900 pr-4" data-id="element-146">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-slate-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-147" />
              </button>
              <AnimatePresence data-id="element-148">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-149">
                    <div className="px-6 pb-6 text-slate-700 leading-relaxed" data-id="element-150">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}